import { getSeatChart } from "api/chart";
import { ToastType } from "components/toast/types";
import { Error } from "constants/common";
import { usePathname } from "next/navigation";
import { useContext } from "react";
import { triggerPageLoadEvent } from "src/containers/chart/chartUtils";
import { ChartContext } from "src/context/chartsContext/chartContext/context";
import { ResultsContext } from "src/context/resultsContext/context";
import { removeQueryParam, updateQueryParam } from "src/utils/browserHelpers";
import { getUTMData } from "src/utils/uiHelpers";

const useGetChartData = (
  setShowToast?: (val: boolean, message: string, type: ToastType) => void
) => {
  const { setShowSeatLayout, showSeatLayout } = useContext(ResultsContext);
  const { setChartData, setLoading, clearChartContext, chartData } =
    useContext(ChartContext);
  const pathName = usePathname();

  const handleSeatChart = async (
    solutionId: string,
    searchId: string,
    triggerBusUIAction?: () => void
  ) => {
    if (showSeatLayout && chartData?.hasOwnProperty(solutionId)) {
      setShowSeatLayout(false);
      if (!pathName?.includes("chart")) removeQueryParam("solutionId");
      return;
    }
    if (triggerBusUIAction) triggerBusUIAction();
    if (chartData?.[solutionId]) {
      setLoading(solutionId);

      updateQueryParam("solutionId", solutionId);
      setShowSeatLayout(true);
      triggerPageLoadEvent(chartData?.[solutionId], getUTMData());

      return;
    }
    setLoading(solutionId);
    try {
      const response = await getSeatChart(
        {
          solutionId: solutionId,

          searchId: searchId,
          itineraryId: null,
        },
        "meta?.operatorName"
      );
      if (response.data?.success) {
        clearChartContext();

        updateQueryParam("solutionId", solutionId);
        setShowSeatLayout(true);
        setChartData({
          [solutionId]: response.data.data,
        });
        triggerPageLoadEvent(response.data.data, getUTMData());
      } else {
        if (setShowToast)
          setShowToast(true, Error.SOMETHING_WENT_WRONG, "warning");
        setLoading("");
      }
    } catch (e) {
      if (setShowToast)
        setShowToast(true, Error.SOMETHING_WENT_WRONG, "warning");

      console.error(e);
      setLoading("");
    }
  };

  const handleHideSeatLayout = () => {
    setShowSeatLayout(false);
    removeQueryParam("solutionId");
  };

  return { handleHideSeatLayout, handleSeatChart };
};

export default useGetChartData;
